import { connect } from 'react-redux';
import ChangeCommenterNameModalComponent
  from './../Components/ChangeCommenterNameModalComponent.jsx';
import {
  modal as modalActions,
  annotations as annotationActions
} from './../actions';
import {
  getModalInfoByOwner,
  getModalVisibility,
  getScenarioById,
  getFullPath,
  getActivePage
} from './../reducers';
import { owners } from './../helpers/modals';
import { annotation, auth } from './../helpers';

export const mapStateToProps = (state) => {
  const modalInfo = getModalInfoByOwner(state, owners.changeCommenterName);
  const visible = getModalVisibility(state, owners.changeCommenterName);
  const status = modalInfo.status;
  const position = modalInfo.position;
  const scenario = getScenarioById(state, modalInfo.scenarioId);
  return {
    visible: visible,
    scenario: scenario,
    position: position,
    status: status
  };
};

export const mapDispatchToProps = dispatch => {
  return {
    hide: () => dispatch(modalActions.showChangeCommenterName(false, 0, '', '')),
    submit: (commentInfo) => dispatch(dispatchSubmitAction(commentInfo)),
  };
};

export const dispatchSubmitAction = (commentInfo) => {
  return (dispatch, getState) => {
    dispatch(annotationActions.addScenarioComment(
      commentInfo.scenario,
      annotation.createPayloadFromInfo(commentInfo)));

    const authToken = auth.getAuthToken();
    const state = getState();
    const routerPath = getFullPath(state);
    const activePage = getActivePage(state);
    if (auth.checkAuthenticated() && commentInfo.ticket)
      dispatch(modalActions.updateJiraIssueDescription(
        commentInfo, authToken, routerPath, activePage)
      );
    dispatch(modalActions.showChangeCommenterName(false, 0, '', ''));
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ChangeCommenterNameModalComponent);


// WEBPACK FOOTER //
// src/Containers/ChangeCommenterNameModalContainer.jsx